import { callerCreator } from "../callerCreator";
import { architectureSlice } from "./architectureSlice";

export default callerCreator(architectureSlice.actions);
